export default __webpack_public_path__ + "static/media/solidity.9b91ae3f.png";